import { useEffect, useState } from 'react'

interface ApiState<T> {
  data: T | null
  error: Error | null
  loading: boolean
}

interface KeyedApiState<T> extends ApiState<T> {
  key: string
}

export function useApi<T>(
  key: string,
  loader: (signal: AbortSignal) => Promise<T>,
): ApiState<T> {
  const [state, setState] = useState<KeyedApiState<T>>({
    key,
    data: null,
    error: null,
    loading: true,
  })

  useEffect(() => {
    const controller = new AbortController()
    loader(controller.signal)
      .then((data) => setState({ key, data, error: null, loading: false }))
      .catch((error: unknown) => {
        if (error instanceof DOMException && error.name === 'AbortError') return
        setState({
          key,
          data: null,
          error: error instanceof Error ? error : new Error('Errore sconosciuto'),
          loading: false,
        })
      })
    return () => controller.abort()
    // The key intentionally controls when a request is repeated.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key])

  return state.key === key
    ? state
    : { data: null, error: null, loading: true }
}
